import React, { memo, Suspense, useState } from 'react';
import { useDispatch } from 'react-redux';
import useFetchTasks from '../../hooks/tasks/useFetchTasks';
import { setSelectedTaskAction } from '../../redux/actions/tasksActions';
import CommonLoader from '../shared/loaders/CommonLoader';
import EmptyContent from '../shared/table/EmptyContent';
import DeleteTaskModal from './modals/DeleteTaskModal';
import UpdateTaskModal from './modals/UpdateTaskModal';
import TasksTable from './TasksTable';

const TasksList = ({ readOnly }) => {
  const dispatch = useDispatch();
  const { loading, tasks, refresh } = useFetchTasks({ unpaged: false });
  const [showUpdateTaskModal, setShowUpdateTaskModal] = useState(false);
  const [showDeleteTaskModal, setShowDeleteTaskModal] = useState(false);

  const handleTaskClick = (task) => {
    dispatch(setSelectedTaskAction(task));
    setShowUpdateTaskModal(true);
  };

  const handleUpdateTaskModalSubmit = async () => {
    refresh();
    setShowUpdateTaskModal(false);
  };

  const handleTaskDeleteClick = (task) => {
    dispatch(setSelectedTaskAction(task));
    setShowDeleteTaskModal(true);
  };

  const handleDeleteTaskModalSubmit = async () => {
    refresh();
    setShowDeleteTaskModal(false);
  };

  return (
    <Suspense fallback={<CommonLoader />}>
      <div className="flex flex-col items-center">
        {showUpdateTaskModal && (
          <UpdateTaskModal
            readOnly={readOnly}
            onModalSubmit={() => handleUpdateTaskModalSubmit()}
            onModalClose={() => setShowUpdateTaskModal(false)}
          />
        )}
        {showDeleteTaskModal && (
          <DeleteTaskModal
            onModalSubmit={() => handleDeleteTaskModalSubmit()}
            onModalClose={() => setShowDeleteTaskModal(false)}
          />
        )}
        <>
          <TasksTable
            onTaskClick={handleTaskClick}
            onTaskDeleteClick={handleTaskDeleteClick}
            tasks={tasks}
            readOnly={readOnly}
            loading={loading}
          />
          {tasks.length === 0 && !loading && <EmptyContent title={'Список послуг порожній'} />}
        </>
      </div>
    </Suspense>
  );
};

export default memo(TasksList);
